import moment from 'moment';

export default {
    methods: {
        /**
         * format 12-month historical data into 18 months
         * @param  {Array} data12Months 12-month data
         * @param  {Function} formatter   formatter callback
         * @return {Array}              18-month data
         */
        formatHistoricalData(data12Months, formatter) {
            // build 18 months of historical values from 12 months of data
            // use the last 13 months, plus the next 5 months

            // clone the year of data to form last year, this year, next year
            const currentMonth = moment().get('month');
            const lastYear = moment().subtract(1, 'years').startOf('year');
            const data3Years = data12Months.concat(data12Months, data12Months).map((e, i) => {
                const date = lastYear.clone().add(i, 'months');
                const days = [];
                for (let num = 0; num < date.daysInMonth(); num++) { // eslint-disable-line no-plusplus
                    const day = date.clone().add(num, 'days');
                    days.push(formatter(day, e));
                }
                return days;
            });
            const data18Months = [];
            data3Years.slice(currentMonth, currentMonth + 19).forEach((month) => {
                data18Months.push(...month);
            });
            return data18Months;
        },
    },
};



// WEBPACK FOOTER //
// ./src/mixins/formatHistoricalMonthlyData.js